export function statusFromPercent (pct) {
  /* deal with missing / NaN first */
  if (pct === null || pct === undefined || Number.isNaN(pct)) {
    return 'unknown';
  }

  if (pct <= 33)   return 'poor';          // 0 – 33
  if (pct <  66)   return 'satisfactory';  // 34 – 65
  return 'good';                           // 66 – 100
}